module.exports = __webpack_public_path__ + "static/media/message-list-icon.5fe2fba7.svg";